import { render } from "./DepartmentIndex.vue?vue&type=template&id=1fb6a962&scoped=true"
import script from "./DepartmentIndex.vue?vue&type=script&lang=js"
export * from "./DepartmentIndex.vue?vue&type=script&lang=js"

import "./DepartmentIndex.vue?vue&type=style&index=0&id=1fb6a962&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb6a962"]])

export default __exports__